<template>
  <b-sidebar
    id="sidebar-invoice-add-new-customer"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Pelanggan
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >

        <!-- Checkbox to save customer -->
        <b-form-group>
          <b-form-checkbox
            v-model="customer.is_saved"
            :value="1"
            :unchecked-value="false"
          >
            Simpan sebagai pelanggan tetap
          </b-form-checkbox>
        </b-form-group>

        <!-- Customer Name -->
        <b-form-group
          label-for="customer-name"
        >
          <template #label>
            Nama Pelanggan <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="customer-name"
            v-model="customer.name"
            trim
            placeholder="Jhon Wiranto"
          />
        </b-form-group>

        <!-- Phone -->
        <b-form-group
          label="No HP"
          label-for="phone"
        >
          <template #label>
            No HP <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="contact"
            v-model="customer.phone"
            type="number"
            placeholder="081xxxxxxxxx"
            trim
          />
        </b-form-group>

        <!-- Email -->
        <b-form-group
          label="Email"
          label-for="email"
        >
          <b-form-input
            id="email"
            v-model="customer.email"
            trim
            placeholder="example@domain.com"
            type="email"
          />
        </b-form-group>

        <!-- Address -->
        <b-form-group
          label="Alamat Lengkap"
          label-for="address"
        >
          <b-form-textarea
            id="address"
            v-model="customer.address_line1"
            placeholder="Contoh : Jalan Warujayeng"
            trim
          />
        </b-form-group>

        <!-- Provinsi -->
        <b-form-group
          label="Provinsi"
          label-for="country"
        >
          <b-form-input
            id="province"
            v-model="customer.province"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            type="text"
            trim
          />
        </b-form-group>

        <!-- City -->
        <b-form-group
          label="Kabupaten / Kota"
          label-for="city"
        >
          <b-form-input
            id="city"
            v-model="customer.city"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            type="text"
            placeholder="Contoh : Kota Surabaya"
            trim
          />
        </b-form-group>

        <!-- subdistrict -->
        <b-form-group
          label="Kecamatan"
          label-for="subdistrict"
        >
          <b-form-input
            id="subdistrict"
            v-model="customer.subdistrict"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            type="text"
            trim
          />
        </b-form-group>

        <!-- village -->
        <b-form-group
          label="Kelurahan"
          label-for="village"
        >
          <b-form-input
            id="village"
            v-model="customer.village"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            type="text"
            trim
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submitCustomer(hide)"
          >
            Tambah
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Batal
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  methods: {
    submitCustomer(hide) {
      this.$emit('submitCustomer', this.customer)
      hide()
      this.customer = {
        name: '',
        email: '',
        address_line1: '',
        province: '',
        city: '',
        subdistrict: '',
        village: '',
        phone: '',
        is_saved: false,
        is_member: false,
      }
    },
  },
  setup() {
    const customer = ref({
      name: '',
      email: '',
      address_line1: '',
      province: '',
      city: '',
      subdistrict: '',
      village: '',
      phone: '',
      is_saved: false,
      is_member: false,
    })

    return {
      customer,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
